<template>
  <div id="epaper_detail" class="">
    <div v-if="is_mini()||is_xbrmcb()||is_xhnyzs()" class="epaper_nav">
      <div  @click="toback">返回版面</div>
      <span>{{bt}}</span>
      <!-- <div v-if="isXhn()" @click="share">分享</div>
      <div style="visibility: hidden;" v-else>分享</div> -->
    </div>
    <div v-if="!is_xhn" class="index_top_app">
        <p id="m-voc-com-cn"><img src="https://m.voc.com.cn/assets/portal/images/xhn-logo.png" alt="新湖南">湖南日报新媒体</p>
        <div>
            <a href="https://m.voc.com.cn"><img src="https://m.voc.com.cn/assets/portal/images/home.png" alt=""></a>
                    <span><a href="https://h5-xhncloud.voc.com.cn/xinhunan?pkgname=com.dingtai.wxhn.activity">打开</a></span>
                </div>
    </div>
    <div :class="'epaper_scroll'">
      <span class="epaper_yt">{{article.YT}}</span>
      <h1 v-if="article.BT" class="epaper_title">{{article.BT}}</h1>
      <h2 v-if="article.FB" class="epaper_title1">{{article.FB}}</h2>
      <h2 v-if="article.AU" class="epaper_title1">{{article.AU}}</h2>
      <h2 v-if="article.PN&&article.BC&&article.BM&&article.DATE" class="epaper_title1">[来源:{{article.PN}}-{{article.BC}}版 {{article.BM}} {{article.DATE}}]</h2>
      <div class="epaper_html">
          <div :key="index" v-for="(item,index) in ct">
            <img :src="item[0]" alt="">
            <div v-html="item[1]">

            </div>
          </div>
          <div v-html="epager_html">

          </div>
      </div>
    </div>
  </div>
</template>

<script>
import '../assets/js/jquery-3.1.1.min.js'
import plugins from '@/plugins'
import {mapState} from 'vuex'
export default {
  mixins:[plugins],
  data(){
    return{
      kid:'',
      epager_html:'',
      ct:[],
      title:'',
      bt:'',
      article:{}
    }
  },
  computed:{
        ...mapState(['is_xhn'])
    },
  mounted(){
    // console.log(this.$route);
    // if(this.$route.query.kid){
    //   this.kid = this.$route.query.kid;
    //   this.$store.state.api.getarticle({kid:this.kid}).then(res=>{
    //     console.log(res)
    //   })
    // }
  },
  activated(){
    window['startPaperShare'] = () =>{
                let post_data = {
                    "share_title": this.article.BT,
                    "share_des": "",
                    "share_img": "",
                    "share_url": location.href,
                    "content_type": "0",
                    "poster_img": '',
                    "share_type": "0"
                }
                console.log(this.post_data)
                vmobile.beginCutomerShare(JSON.stringify(post_data))
  }
    // this.bt = this.$store.state.papertitle;
    if(this.$route.query.kid){
      this.kid = this.$route.query.kid;
      this.$store.state.api.getarticle({kid:this.kid}).then(res=>{
        if(res.TX){
          this.epager_html = res.TX;
        }
        if(res.CT){
          this.ct = res.CT
        }
        this.bt = res.BT+'-湖南日报电子版';
        this.title = res.BT;
        this.article = res;
        document.title = res.BT;
        // console.log(eval("'" +res+ "'"))
        var that = this;
        let shareUrl = window.location.href
        $.ajax({
              url: "//cgi.voc.com.cn/api/weixin/xhn.php?url="+encodeURIComponent(shareUrl),
              dataType: 'json',
              success:  (data)=> {
                  $.each(data,  (index, result) =>{
                      if (result['status'] == 1) {
                          var appId = result['appId'],
                timestamp = result['timestamp'],
                nonceStr = result['nonceStr'],
                signature = result['signature'];
                          jWeixin.config({
                              debug: false,
                              appId: appId,
                              timestamp: timestamp,
                              nonceStr: nonceStr,
                              signature: signature,
                              jsApiList: [
                    'onMenuShareTimeline',
                    'onMenuShareAppMessage',
                    'onMenuShareQQ',
                    'onMenuShareWeibo'
                              ]
                          });
                      }
                  });

              }
						    });
        jWeixin.ready(function () {
							var shareTitle = res.BT,
							    shareUrl = window.location.href,
								  shareDesc = res.DESC,
                  shareImg = that.$store.state.shareimg;
						        jWeixin.onMenuShareAppMessage({
						            title: shareTitle,
						            imgUrl: shareImg,
									      desc: shareDesc,
						            link: shareUrl,
						            success: function (res) {
									
						            }
						        });
						
						        jWeixin.onMenuShareTimeline({
						            title: shareTitle,
						            imgUrl: shareImg,
									      desc: shareDesc,
						            link: shareUrl,
						            success: function (res) {
						
						            }
						        });
						
						        jWeixin.onMenuShareQQ({
						            title: shareTitle,
						            imgUrl: shareImg,
									      desc: shareDesc,
						            link: shareUrl,
						            success: function (res) {
						
						            }
						        });
						
						        jWeixin.onMenuShareWeibo({
						            title: shareTitle,
						            imgUrl: shareImg,
									      desc: shareDesc,
						            link: shareUrl,
						            success: function (res) {
						
						            }
                    });
						    });
      })
      let arr = [
        {key:'channel_id',value:'H5'},
        {key:'screen',value:'newspaper_detail'},
        {key:'newspaper_id',value:this.$route.query.kid}
    ]
    this.matomo_fn(arr,'电子版详情')
    };
  },
  deactivated(){
    this.epager_html = '';
    this.title = '';
    this.ct = [];
    this.article = {};
    this.bt = '';
  },
  methods:{
    is_mini(){//是否小程序判断
      return window.__wxjs_environment === 'miniprogram';
    },
    is_xbrmcb(){
      var UA = window.navigator.userAgent;
      return UA.startsWith("xbrmcb-")
    },
    is_xhnyzs(){
      var UA = window.navigator.userAgent;
      return UA.startsWith("xhnyzs-")
    },
    toback(){
      this.$router.push({path:'/'})
    },
    isXhn(){
			var UA = window.navigator.userAgent;
			var isAndroid = UA.indexOf('Android') > 0;
			var isIOS = /iPhone|iPad|iPod|iOS/.test(UA);
			var isXinhunan = false;
			
        if (isAndroid || isIOS) {
          //确定是在安卓,苹果手机中再判断是否在新湖南(ios 12 UA会写入失败，这里忽略)
          if(UA.substring(0, 4) === "xhn-" || UA.startsWith("Mozilla/5.0 (iPhone; CPU iPhone OS 12"))
          {
            isXinhunan = true;
          }	
        }
        return isXinhunan
      },
      share(){
        var share_share = {};
        share_share.share_title = this.article.BT;
        share_share.share_des = this.article.DESC;
        share_share.share_img = this.$store.state.shareimg;
        share_share.share_url = location.href;
        vmobile.beginShare(JSON.stringify(share_share))
      }
  }
}
</script>

<style lang="scss" scoped>
.index_top_app{
      height: 44Px;
      border-bottom: 0.5Px solid #EFEFEF;
      padding: 0 16Px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 16Px;
  }
  .index_top_app p{
      display: flex;
      align-items: center;
  }
  .index_top_app p img{
      width: 60Px;
      padding-right: 10.4Px;
  }
  .index_top_app div{
      display: flex;
      align-items: center;
  }
  .index_top_app div img{
      width: 20.8Px;
      margin: 4Px 21Px 0 0;
  }
  .index_top_app span{
      display: inline-block;
      width: 70Px;
      height: 27Px;
      background: linear-gradient(158deg, #FF583A 0%, #FF583A 1%, #FF3028 100%);
      border-radius: 1Px;
      text-align: center;
      line-height: 27Px;
  }
  .index_top_app span a{
      color: #fff;
      text-decoration: none !important;
  }
#epaper_detail{
  display: flex;
  flex-direction: column;
  height: 100vh;
  overflow: hidden;
  .epaper_scroll{
    width: 100%;
    overflow-y: auto;
    flex: 1;
    &.epaper_scroll_app{
      height: calc(100vh);
    }
  }
  .epaper_yt{
    font-size: 30px;
    display: block;
    text-align: center;
    color: black;
  }
  .epaper_title{
    padding:10px;
    font-size: 40px;
    text-align: center;
  }
  .epaper_title1{
    padding:10px;
    font-size: 35px;
    font-weight: normal;
    margin: 20px auto;
  }
  .epaper_nav{
    width: 100%;
    height: 88px;
    left: 0;
    top: 0;
    background: #f8f8f8;
    border-bottom: 1px solid #e9e9e9;
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    &>div{
      display: inline-block;
      line-height: 64px;
      border: 1px solid #b2b2b2;
      font-size: 26px;
      color: #444;
      padding: 0 10px;
    }
    &>span{
      font-size: 34px;
      display: block;
      text-align: center;
      margin-left: 10px;
      flex: 1;
      white-space: nowrap;/*内容超宽后禁止换行显示*/
      overflow: hidden;/*超出部分隐藏*/
      text-overflow:ellipsis;/*文字超出部分以省略号显示*/
    }
  }
  .epaper_nav_bank{
    width: 100%;
    height: 88px;
  }
  .epaper_html{
    padding: 20px;
    /deep/div{
      font-size: 35px;
       p{
        margin-top: 32px;
        margin-bottom: 32px;
      }
      img{
        max-width: 100%;
        margin: auto;
      }
      p{
        font-size: 35px;
      }
    }
  }
}
</style>